import { HttpInterceptorFn } from '@angular/common/http';

export const getAuthToken = (): string => {
    // First check for third-party token
    const apiTokenStr = localStorage.getItem('apiToken');
    if (apiTokenStr) {
        try {
            const tokenInfo = JSON.parse(apiTokenStr);
            if (tokenInfo.value && Date.now() <= tokenInfo.expiry) {
                return tokenInfo.value;
            }
        } catch {
            // Continue to Okta token check
        }
    }

    // Check for CSR Okta token
    const tokenStorage = localStorage.getItem('okta-token-storage');
    if (tokenStorage) {
        const { accessToken } = JSON.parse(tokenStorage);
        return accessToken?.accessToken || '';
    }
    return '';
};

export const authInterceptor: HttpInterceptorFn = (req, next) => {
    const token = getAuthToken();
    // Third-party flow: when a TP sessionId is stored, the Orchestrator
    // authenticates from the `sessionId` request header and no `Authorization`
    // header must be sent. Suppress the Bearer token for those requests.
    const hasTpSession = !!sessionStorage.getItem('tpSessionId');
    const skipAuth = req.url.endsWith('/multidata') || req.url.includes('api.zerobounce.net') || req.url.includes('execute-api.us-west-2.amazonaws.com') || req.url.includes('/auth/session') || req.headers.has('Authorization') || (hasTpSession && req.headers.has('sessionId'));
    if (token && !skipAuth) {
        const clonedReq = req.clone({
            setHeaders: {
                Authorization: `Bearer ${token}`,
            },
        });
        return next(clonedReq);
    }
    

    return next(req);
};
